import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {toDateTimeString} from "../../providers/app-date-adapter";
import {ActivatedRoute, Router} from "@angular/router";
import {RoleService} from "../../services/role.service";
import {CompanyService} from "../services/company.service";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {BankTransferLoadService} from "../../bank-transfer-load.service";
import {AppMatCustomAction} from "../../shared/mat-table-generator/mat-table-core/app-mat-custom-action";
import {BankTransferLoad} from "../../dto/bankTransferLoad";
import {TrustPayService} from "../../trust-pay.service";
import {TrustPayTransaction} from "../../dto/trustPayTransaction";
import {TrustPayUnlinkedService} from "../../trust-pay-unlinked.service";
import {FileHelper} from "../../helpers/file-helper";
import {ToastService} from "angular-toastify";
import {ConfirmDialogComponent} from "../../shared/confirm-dialog/confirm-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {MatButtonToggle} from "@angular/material/button-toggle";

import {Company} from "../../dto/company";
import * as moment from "moment/moment";
import {TrustpayTransactionStatus} from "../../dto/payment-source";
import {LoadRiskFlags} from "../../dto/loadRiskFlags";


@Component({
  selector: 'app-btl',
  templateUrl: './btl.component.html',
  styleUrls: ['./btl.component.css']
})
export class BtlComponent implements OnInit, OnDestroy {
  private companies: Company[];
  public isTransactionsLoading = false;
  public isPendingLoading = false;
  public isPreApprovedLoading = false;
  public isDelayedLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private bankTransferLoadService: BankTransferLoadService,
    private trustPayService: TrustPayService,
    private trustPayUnlinkedService: TrustPayUnlinkedService,


    private snackBar: MatSnackBar,
    public companiesService: CompanyService,
    private _toastService: ToastService,
    private dialog: MatDialog,
  ) {
  }
  isImporting: boolean;

  isBusy = false;



  //@ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;
  //@ViewChild(MatTableGeneratorComponent, {static: true}) table2: MatTableGeneratorComponent;
  @ViewChild(MatButtonToggle, {static: false}) allButton: MatButtonToggle;

  dataSourcePending = new MultiCrudDataSource(this.bankTransferLoadService);
  dataSourcePreApproved = new MultiCrudDataSource(this.bankTransferLoadService, {getManyOverride: (
  pageIndex, pageSize, sortField, sortDirection, filterString, dateFilterCols, startFilterDate, endFilterDate, someAdditionalData, additionalFilterData, enumFilter, companiesFilter) => {
  const fs = this.bankTransferLoadService.getPreApproved(
    pageIndex,
    pageSize,
    sortField,
    sortDirection,
    filterString,
    dateFilterCols,
    startFilterDate,
    endFilterDate,
    someAdditionalData,
    additionalFilterData,
    enumFilter,
    companiesFilter
  );
  return fs;
}});
  dataSourceDelayed = new MultiCrudDataSource(this.bankTransferLoadService, {getManyOverride: (
      pageIndex, pageSize, sortField, sortDirection, filterString, dateFilterCols, startFilterDate, endFilterDate, someAdditionalData, additionalFilterData, enumFilter, companiesFilter) => {
      const fs = this.bankTransferLoadService.getDelayed(
        pageIndex,
        pageSize,
        sortField,
        sortDirection,
        filterString,
        dateFilterCols,
        startFilterDate,
        endFilterDate,
        someAdditionalData,
        additionalFilterData,
        enumFilter,
        companiesFilter
      );
      return fs;
    }});
  columns = [
    {columnDef: 'createDate', header: 'Created', cell: (row: BankTransferLoad) => `${toDateTimeString(row.createDate) || ''}`},
    {columnDef: 'loadType', header: 'Type', icon: (row: BankTransferLoad) => row.loadType == 1 ? 'account_balance' : 'assignment_ind', cell: (row: BankTransferLoad) => `${row.loadType == 1 ? 'Bank':'Partner'}`, cellColor: (row: BankTransferLoad) => `${row.loadType == 1 ? 'grey':'blue'}`},
    {columnDef: 'amount', header: 'Amount', cell: (row: BankTransferLoad) => `${row.amountToLoad.formatMoneyCcy(row.currencyCode)}`},
    {columnDef: 'loadFee', header: 'Fee', cell: (row: BankTransferLoad) => `${row.loadFee.formatMoneyCcy(row.currencyCode)}`},
    {columnDef: 'card', sortable: false, header: 'Card', cell: (row: BankTransferLoad) => `${row.card.token}`},
    {columnDef: 'status', sortable: false, header: 'Status', cell: (row: BankTransferLoad) => false, icon: (row: BankTransferLoad) => {
        if (row.isApprovedAutomatically && !row.isApprovedManually && !row.isDeclinedManually) {
          return 'done';
        }
        if (row.isApprovedManually && !row.isDeclinedManually) {
          return 'done';
        }
        if (row.isDeclinedManually) {
          return 'clear';
        }
        if (row.needsManualApproval && !row.isApprovedManually && row.isPreApprovedManually) {
          return 'group_work';
        }

        if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually) {
          return 'warning';
        }


      }, cellColor: (row: BankTransferLoad) => {
        if (row.isDeclinedManually) {
          return 'red';
        }
        if (row.isApprovedAutomatically && row.needsManualApproval && !row.isApprovedManually && !row.isDeclinedManually) {
          return 'dodgerblue';
        }
        if (row.isApprovedManually && !row.isDeclinedManually) {
          return 'forestgreen';
        }
        if (row.isApprovedAutomatically && !row.needsManualApproval) {
          return 'dodgerblue';
        }
        if (row.needsManualApproval && !row.isApprovedManually && row.isPreApprovedManually) {
          return 'purple';
        }
        if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually) {
          return 'orange';
        }
      }
      },
    {columnDef: 'statusText', sortable: false, header: '', cell: (row: BankTransferLoad) => {
        let ret = '';
        if (row.isDeclinedManually) {
          ret += 'Declined ';
        } else if (row.isApprovedAutomatically && row.needsManualApproval && !row.isApprovedManually && !row.isDeclinedManually) {
          ret += 'Pending';
        } else if (row.isConfirmed && row.amountAlreadyLoaded >= row.amountToLoad) {
          ret += 'Loaded in full';
        } else if (row.isConfirmed && row.amountAlreadyLoaded < row.amountToLoad && row.amountAlreadyLoaded > 0) {
          ret += 'Loaded partially';
        } else if (row.isApprovedAutomatically && !row.needsManualApproval) {
          ret += 'Approved automatically';
        } else if (row.isApprovedManually && !row.isDeclinedManually) {
          ret += 'Approved';
        } else if (row.needsManualApproval && !row.isApprovedManually && row.isPreApprovedManually) {
          ret += 'Needs second approval';

        } else if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually && row.needsPreApproval) {
          ret += 'Needs pre-approval';
        } else if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually && !row.needsPreApproval) {
          ret += 'Needs approval';
        }

        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.ThirdPartyLoad) ) {
          ret += " (Third-Party)"
        }
        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.FrequencyExceeded) ) {
          ret += " (Frequency)"
        }
        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.LimitExceeded) ) {
          ret += " (Limit)"
        }
        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.InvalidCardStatus) ) {
          ret += " (Card status)"
        }
        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.RiskDeterminationError) ) {
          ret += " (Risk Error)"
        }
        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.NeedsPreApproval) ) {
          ret += " (Need 4-eyes)"
        }
        if ( this.hasLoadRiskFlag(row.riskFlags, LoadRiskFlags.MinAmountSubceeded) ) {
          ret += " (Min. Amt.)"
        }

        const isDelayedNow = row.delayedIndefinitely || (row.delayNextLoadUntil && moment(row.delayNextLoadUntil).isAfter());
        if ( isDelayedNow)
          ret += " (Delayed)";


        return ret.trim();
      }},
    {cell: (row: BankTransferLoad) => (row.amountAlreadyLoaded > 0 && row.amountAlreadyLoaded < row.amountToLoad) ? row.amountAlreadyLoaded.formatMoneyCcy(row.currencyCode) : false, columnDef: 'isExported', header: 'Exported', icon: (row: BankTransferLoad) => {
        if (row.isExported) {
          return 'file_download_done';
        }
        if ( row.amountAlreadyLoaded > 0) {
return 'call_split';
}

        if ( row.isInstantLoad && row.isApprovedAutomatically) {
return 'flash';
}

        return 'hourglass_empty';

      }, cellColor: (row: BankTransferLoad) => {
        if (row.isExported) {
          return 'dodgerblue';
        }
        if ( row.isConfirmed) {
          return 'forestgreen';
        }

        if ( row.amountAlreadyLoaded > 0) {
return 'violet';
}

        if ( row.isInstantLoad && row.isApprovedAutomatically) {
return 'yellow';
}

        return 'grey';

      } },
    {columnDef: 'exportStatus', header: '', cell: (row: BankTransferLoad) => `${row.isExported ? 'Exported' : (row.amountAlreadyLoaded > 0 ? 'Partially exported' : 'Not exported')}`},



  ];

  dataSourceTransactions = new MultiCrudDataSource(this.trustPayUnlinkedService);

  columnsTransactions = [
    {columnDef: 'createDate', header: 'Created', cell: (row: TrustPayTransaction) => `${toDateTimeString(row.createDate) || ''}`},
    {columnDef: 'source', header: 'Source', cell: (row: TrustPayTransaction) => {
        switch (row.source) {
          case 0 : return "Revolut";
          case 1 : return "Trustpay";
          case 2 : return "Qonto";
          case 3 : return "Commerzbank";
          case 4 : return "MicroPayment";
        }
        return "Unknown";
      }},
    {columnDef: 'amount', header: 'Amount', cell: (row: TrustPayTransaction) => `${row.amount.formatMoneyEuro()}`},
    {columnDef: 'counterAccount', header: 'CounterAccount', cell: (row: TrustPayTransaction) => `${row.counterAccountMasked}`},
    {columnDef: 'counterAccountName', header: 'CounterAccountName', cell: (row: TrustPayTransaction) => `${row.counterAccountName}`},
    {columnDef: 'card', sortable: false, header: 'Card', cell: (row: TrustPayTransaction) => `${row.cardFound ? row.cardFound.token : '-'}`},
    {columnDef: 'missing', sortable: false, header: '_', cellColor: (row: TrustPayTransaction) => {
      if (!row.reference && !row.description) {
        return 'red';
      }
      return 'dodgerblue';
    }, cell: (row: BankTransferLoad) => false, icon: (row: TrustPayTransaction) => {
        if (!row.reference && !row.description) {
          return 'incomplete_circle';
        }
        return false;
    }},



  ];

  isLoading: boolean;

  busyPollerInterval: ReturnType<typeof setTimeout>|null;

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }
  getRowClass = (item: BankTransferLoad): string => {
    const classes = [];
    if ( !item.isApprovedManually && item.needsManualApproval) {
      classes.push('needs-approval');
    }
    if ( item.riskLevel == 2) {
      classes.push('risk-medium');
    }
    if ( item.riskLevel == 3) {
      classes.push('risk-high');
    }
    if ( item.riskLevel == 99) {
      classes.push('risk-unknown');
    }
    return classes.join(' ');
  };

  getRowClassTransaction = (item: TrustPayTransaction): string => {
    const classes = [];
    if ( item.cardFoundId == null) {
      classes.push('needs-card');
    }

    return classes.join(' ');
  };


  hasLoadRiskFlag(haystack: LoadRiskFlags, needle: LoadRiskFlags) {
    return (haystack & needle) == needle;
  }


  ngOnInit(): void {

    this.dataSourceTransactions.loading$.subscribe(value => this.isTransactionsLoading = value);
    this.dataSourcePending.loading$.subscribe(value => this.isPendingLoading = value);
    this.dataSourcePreApproved.loading$.subscribe(value => this.isPreApprovedLoading = value);
    this.dataSourceDelayed.loading$.subscribe(value => this.isDelayedLoading = value);

    this.startIsBusyCheck();
    this.rebuildTransCustomActions();



  }

  ngOnDestroy() {
    if ( this.busyPollerInterval ) {
clearInterval(this.busyPollerInterval);
}
  }

  View(bankTransferLoad: BankTransferLoad) {
    this.router.navigate([bankTransferLoad.id], {relativeTo: this.route});
  }

  Edit(bankTransferLoad: BankTransferLoad) {
    this.router.navigate([bankTransferLoad.id, 'edit'], {relativeTo: this.route});
  }

  getViewLink = (item: BankTransferLoad): string => item.id.toString();

  getEditLink = (item: BankTransferLoad): string => item.id.toString() + '/edit';

  ViewTransaction(item: TrustPayTransaction) {
    this.router.navigate(['transaction', item.id], {relativeTo: this.route});
  }

  EditTransaction(item: TrustPayTransaction) {
    this.router.navigate(['transaction', item.id, 'edit'], {relativeTo: this.route});
  }

  getViewLinkTransaction = (item: TrustPayTransaction): string => 'transaction/' + item.id.toString();

  getEditLinkTransaction = (item: TrustPayTransaction): string => 'transaction/' + item.id.toString() + '/edit';
  public transCustomactions: AppMatCustomAction[] = [];
  uploadOpened = false;

  rebuildTransCustomActions() {

    if (this.roleService.hasRoles('admin')) {
      this.transCustomactions = [
        new AppMatCustomAction('undo', 'refund selected loads', false, (row: TrustPayTransaction) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Refund',
              text: 'Are you sure you want to refund the selected loads?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.refundTransaction(row);
              }
            });
        }),

      ];
    }
  }


  editEnabled() {
    return false;
  }

  deleteLoadsEnabled() {
    return false;
  }

  deleteTransactionsEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'compliance','finance_manager']);
  }

  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }

  startIsBusyCheck() {
    if (this.busyPollerInterval) {
      clearInterval(this.busyPollerInterval);
      this.busyPollerInterval = null;
    }
    this.checkIsBusy();
    this.busyPollerInterval = setInterval(() => this.checkIsBusy(), 5000);
  }
  checkIsBusy() {
    this.trustPayService.getIsBusy()
      .subscribe(result => {
        this.isBusy = result;
        console.log('busy: ' + this.isBusy);
        if (!this.isBusy) {
          clearInterval(this.busyPollerInterval);
          this.busyPollerInterval = null;
          this.dataSourcePending.loadData();
          this.dataSourceTransactions.loadData();

        }
      }, err => {
        this._toastService.warn('Failed to poll busy status');
      });
  }

  onUploadImportCsv(file: any, source: string) {
    this.isLoading = true;
    this.isImporting = true;

    if ( source == 'trustpay') {
      this.trustPayService.uploadImportCsv(file)
        .subscribe(
          result => {
            this.startIsBusyCheck();
            this.isBusy = true;
            this.isLoading = false;
            this.isImporting = false;

            // window.location.reload();
          },
          err => {
            this.snackBar.open(err.error.message || err.error || err.message || err, null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
            this.isLoading = false;
            this.isImporting = false;

          }
        );
    } else if ( source == 'commerzbank') {
      this.trustPayService.uploadImportCsvCommerzbank(file)
        .subscribe(
          result => {

            // if transactions need to be checked, we transfer to the txn import summary page
            let needsCheck = false;
            result.forEach(value => needsCheck = needsCheck || value.status != TrustpayTransactionStatus.AutoCommitted);
            if ( needsCheck ) {
              this.router.navigate(['../needs-check'], {relativeTo: this.route}).then();
              return;
            }

            this.startIsBusyCheck();
            this.isBusy = true;
            this.isLoading = false;
            this.isImporting = false;

            // window.location.reload();
          },
          err => {
            this.snackBar.open(err.error.message || err.error || err.message || err, null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
            this.isLoading = false;
            this.isImporting = false;

          }
        );
    }


  }

  gotToGpsHistory(){
    this.router.navigate(['gps-load-response', 'history'], {relativeTo: this.route});
  }

  goToLastLoadFiles() {
    this.router.navigate(['last-load', 'files'], {relativeTo: this.route});
  }

  goToLoadRefundList() {
      this.router.navigate(['load-refunds/list'], {relativeTo: this.route});
  }

  downloadLoads() {

    this._toastService.error('disabled');
    return;

    this.isBusy = true;
    this.bankTransferLoadService.downloadLoads().subscribe(
      result => {
        FileHelper.saveFile( result );
        this.dataSourcePending.loadData();
        this.dataSourceTransactions.loadData();
        // this.goToLastLoadFiles();
        this.isBusy = false;
      },
      err => {
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        });
        this.isBusy = false;
      }
    );
  }

  uploadGpsLoadResponse() {

    this._toastService.error('disabled');
    return;

    this.router.navigate(['loads/btl/gps-load-response/upload'], { queryParams: {  }});


  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsFinanceManager() {
 return this.roleService.hasRoles('finance_manager');
}


  private refundTransaction(row: TrustPayTransaction) {
    this.trustPayService.refundTransaction(row.id).subscribe(next => {
      this._toastService.info('Transaction was moved to refund list');
      this.dataSourceTransactions.loadData();
    });

  }


  goToApproval() {
    this.router.navigate(['../needs-check'], {relativeTo: this.route}).then();
    return false;
  }
}
